<template>
  <div class="bbp-completed-projects">
    <div class="bbp-completed-projects-year" v-for="year in years" :key="year">
      <div class="bbp-completed-projects-year__title">{{year}}</div>
      <div class="bbp-completed-projects-year-projects">
        <div class="bbp-completed-projects-year-projects-item"
             :class="{
               'bbp-completed-projects-year-projects-item_open': project.$open,
               'bbp-completed-projects-year-projects-item_first': projectIndex === 0,
               'bbp-completed-projects-year-projects-item_last': projectIndex === completedProjects[year].length - 1
             }"
             v-for="(project, projectIndex) in completedProjects[year]"
             :key="project.id">
          <div class="bbp-completed-projects-year-projects-item-header">
            <div class="bbp-completed-projects-year-projects-item-header__button"
                 :class="{'bbp-completed-projects-year-projects-item-header__button_open': project.$openEnd}"
                 @click="openProject(project)"
            >
              <BBPIconArrows />
            </div>
            <div class="bbp-completed-projects-year-projects-item-header__title"
                 @click="goToProjectCard(project.id)"
            >
              {{project.name}}
            </div>
            <div class="bbp-completed-projects-year-projects-item-header-completed">
              <div class="bbp-completed-projects-year-projects-item-header-completed__date">
                {{formatDate(project.dateEnd)}}
              </div>
              <i class="bbp-icon-checked bbp-completed-projects-year-projects-item-header-completed__icon"/>
            </div>
          </div>
          <ProjectCard
              :view-mode="true"
              :key="project.id"
              :project="project"
              :clientProjects="[project]"
              @loader="setLoader"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectsApi from '@/api/Projects/api'
import ProjectCard from '@/components/Projects/ProjectCard/ProjectCard'
import BBPIconArrows from '@/components/Main/BBPIcons/BBPIconArrows'
import {groupBy, keys} from 'lodash'
import moment from 'moment'

export default {
  name: 'CompletedProjects',
  components: {
    ProjectCard,
    BBPIconArrows
  },
  data () {
    return {
      completedProjects: {}
    }
  },
  computed: {
    years () {
      const stringYears = keys(this.completedProjects)
      const numYears = stringYears.map(year => +year)
      return numYears.sort((a, b) => b - a)
    },
    clientId () {
      return this.$route.params.clientId
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return ''
      const momentDate = moment(date)
      const isValid = momentDate.isValid()
      return isValid ? momentDate.format('DD-MMM-YY') : ''
    },
    goToProjectCard (projectId) {
      this.$router.push({
        name: 'ProjectCard',
        params: {
          projectId: projectId
        }
      })
    },
    openProject (project) {
      const val = !project.$open
      this.$set(project, '$open', val)
      if (val) {
        setTimeout(() => {
          this.$set(project, '$openEnd', val)
        }, 150)
      } else {
        this.$set(project, '$openEnd', val)
      }
    },
    setLoader (val) {
      this.$emit('loader', val)
    },
    getClosedProjectsByClient () {
      this.$emit('loader', true)
      ProjectsApi.getProjects({
        client: this.clientId,
        status: '3',
        sort: 'dateEnd&sort[]=-1',
        projectType: '1&projectType[]=2'
      })
        .then((resp) => {
          const projectWithYear = resp.data.projects.map(project => {
            const dateStart = new Date(project.dateStart)
            project.$year = dateStart.getFullYear()
            return project
          })
          this.completedProjects = groupBy(projectWithYear, '$year')
          this.$emit('loader', false)
        })
        .catch((err) => {
          console.error(err)
          this.$emit('loader', false)
        })
    }
  },
  beforeMount () {
    this.getClosedProjectsByClient()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-completed-projects {
    @include global-font;
    display: grid;
    grid-gap: 30px;

    &-year {
      background: $color-white;
      border-radius: 5px;
      padding: 13px 18px 1px 18px;

      &__title {
        display: inline-block;
        padding: 8px 14px;
        background: rgba($color-accent, 0.15);
        color: $color-accent;
        border-radius: 33px;
        margin-bottom: 9px;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
      }

      &-projects {
        &-item {
          cursor: default;
          height: 49px;
          transition: 0.8s;

          &_open {
            height: 280px;
            margin-bottom: 20px;
            transition: 0.9s;
          }

          &_last {
            border-bottom-color: transparent;;
          }

          &-header {
            display: flex;
            align-items: center;
            justify-content: start;
            color: $color-accent;
            transition: 0.3s;
            padding: 14px 0;
            border-bottom: 1px solid $color-wild-sand;

            &:hover {
              color: $color-accent-hover;
            }

            &__button {
              display: flex;
              align-items: center;
              justify-content: center;
              opacity: 1;
              transition: .3s linear;
              cursor: pointer;

              &:hover {
                opacity: 0.8;
                transition: .3s linear;
              }

              &_open {
                transform-origin: center center;
                transform: rotate(90deg);
              }
            }

            &__title {
              font-weight: 600;
              font-size: 14px;
              line-height: 17px;
              margin-left: 25px;
              cursor: pointer;
            }

            &__arrow-to-project {
              position: relative;
              margin-left: 25px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 21px;
              height: 21px;
              border-radius: 50%;
              background-color: $color-accent;
              color: $color-white;
              font-size: 10px;
              transform: rotate(180deg);
              transition: 0.3s;
              cursor: pointer;

              &:hover {
                background-color: $color-accent-hover;
              }
            }

            &-completed {
              font-size: 14px;
              display: flex;
              align-items: center;
              margin-left: auto;
              margin-right: 0;

              &__date {
                margin-right: 10px;
              }

              &__icon {
                font-size: 20px;
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjectByClient/CompletedProjects.vue